import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { InformacionComercialEnvioComponent } from "./componentes/informacionenviadas";
import { InformacionComercialRecibidasComponent } from "./componentes/informacionrecibidas";
import { InfoComRecibidasPromedioPromedioComponent } from "./componentes/informacionrecibidaspromedio";

type Entity = models.SucursalInformacionComercialMesDTO;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de edición para un SucursalInformacionComercialMes
*/
export class SucursalInformacionComercialMesEdit extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            Mes: validation.required
        };
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Number = getField(kea.Number);
        const InfoComEnvio = getField(InformacionComercialEnvioComponent);
        const InfoComRecibidas = getField(InformacionComercialRecibidasComponent);
        const InfoComRecibidasPromedio = getField(InfoComRecibidasPromedioPromedioComponent);
        
        const MesSelector = getField(selectores.Mes);
        const titulo = "Información comercial mensual";
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={validation.hasError(this.errors())} />]}
                onClose={this.onCerrar}
                title={titulo}
            >

            <MesSelector field="Mes" label="Mes"/>
            <kea.Panel title="Información de envío" iconClass={fa("id-card-o")} style="primary">
                <InfoComEnvio field="GuiasEnv" title="Guias enviadas" format={"int"}/>
                <InfoComEnvio field="PaquetesEnv" title="Paquetes enviados" format={"int"}/>
                <InfoComEnvio field="VentaEnv" title="Venta de enviados" format={"currency"}/>   
            </kea.Panel>
            <kea.Panel title="Información de recibidas" iconClass={fa("id-card-o")} style="success">
                <InfoComRecibidas field="GuiasRec" title="Guias recibidas" format={"int"}/>
                <InfoComRecibidas field="PaquetesRec" title="Paquetes recibidos" format={"int"}/>
                <InfoComRecibidas field="VentasRec" title="Venta recibida"format={"currency"}/>
            </kea.Panel>
            </kea.Modal>
        )
    }
}   



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/edit/informacioncomercial/informacionPorMes/edit.tsx